import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IAppConfig } from './IAppConfig';
@Injectable()
export class AppConfigService {
  static settings: IAppConfig;
  constructor(private http: HttpClient) { }
  load() {
    const jsonFile = `assets/config/appsettings.json`;
    return new Promise<void>((resolve, reject) => {
      this.http.get(jsonFile).toPromise().then((response) => {
        AppConfigService.settings = <IAppConfig>response;
        resolve();
      }).catch((response: any) => {
        reject(`Could not load the config file`);
      });
    });
  }
  public getServerURL() {
    return AppConfigService.settings.serverBaseURL;
  }
  public getStartYear() {
    return AppConfigService.settings.startYear;
  }
  public getIsLive() {
    return AppConfigService.settings.isLive;
  }
  public getTestEmailTo() {
    return AppConfigService.settings.testEmailTo;
  }
  public getSendGridEmailFrom() {
    return AppConfigService.settings.sendGridEmailFrom;
  }
  public getSendGridNameFrom() {
    return AppConfigService.settings.sendGridNameFrom;
  }
}